import React, { useEffect } from "react";
import { ReactComponent as BookmarkIcon } from "assets/icons/bookmark.svg";
import { ReactComponent as DeleteIcon } from "assets/icons/delete_fill.svg";
import { ReactComponent as QuestionMark } from "assets/icons/question_mark.svg";
import { ReactComponent as NotificationIcon } from "assets/icons/notification.svg";
import useBookmark from "hooks/useBookmark";
import useAuth from "hooks/useAuth";

const Card = ({ icon: Icon, count, title }) => (
  <div className="w-full flex flex-col h-[137px] px-2 justify-center items-center border border-[#EEEEEE] rounded-[10px]">
    <div className="bg-[#E8F6FF] flex-shrink-0 w-[52px] h-[52px] rounded-full flex items-center justify-center">
      <Icon
        className="text-primary !stroke-none w-8"
        fill="#1DA1F2"
        stroke="#1DA1F2"
        strokeWidth={0}
      />
    </div>
    <h1 className="text-center mt-[5px] text-[#161616] leading-[24.2px] text-[20px] md:text-[20px] font-semibold">
      <span className="text-primary font-bold text-[20px]">{count} </span>
      {title}
    </h1>
  </div>
);

const WeeklyRecap = () => {
  const {
    getDashboardWeeklySummary,
    isWeeklySummaryFetching,
    dashboardWeeklySummary,
  } = useBookmark();
  const { user } = useAuth();

  useEffect(() => {
    getDashboardWeeklySummary();
  }, [user]);

  return (
    <div className="bg-white rounded-[15px] md:h-[373px] pt-5 md:pt-[18px] px-4 md:px-[17px] pb-5 md:pb-[22px]">
      <h1 className="text-center text-black leading-[30px] text-[22px] md:text-[22px] font-semibold truncate">
        Ecco un Recap degli ultimi 7 giorni
      </h1>
      <div className="mt-5 md:mt-4 md:mx-[11px] flex items-center space-x-[13px]">
        <Card
          icon={BookmarkIcon}
          count={dashboardWeeklySummary?.bookmarksCount}
          title="Aggiunte ai Preferiti"
        />
        <Card
          icon={QuestionMark}
          count={dashboardWeeklySummary?.doubtsCount}
          title="Aggiunte nelle Dubbie"
        />
      </div>
      <div className="flex items-center space-x-[13px] mt-[13px] md:mx-[11px]">
        <Card
          icon={DeleteIcon}
          count={dashboardWeeklySummary?.discardedCount}
          title={
            <>
              Proprietà
              <br />
              Scartate
            </>
          }
        />
        <Card
          icon={NotificationIcon}
          count={dashboardWeeklySummary?.savedSearchesCount}
          title={
            <>
              Ricerche
              <br />
              Salvate
            </>
          }
        />
      </div>
    </div>
  );
};

export default WeeklyRecap;
